import { FadeIn, Overline } from "@/components/Reveal";

const BENEFITS = [
  {
    n: "01",
    title: "Content relevance",
    text: "Find creators whose subject matter aligns with your brand.",
  },
  {
    n: "02",
    title: "Audience alignment",
    text: "Prioritise creators based on their content, audience data and suitability for your campaign.",
  },
  {
    n: "03",
    title: "Thoughtful integrations",
    text: "Develop sponsorship placements that complement the creator's content and respect the audience's viewing experience.",
  },
];

export const Approach = () => (
  <section id="about" className="py-24 md:py-32" data-testid="approach-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
      <div className="md:col-span-5">
        <div className="md:sticky md:top-32">
          <FadeIn>
            <Overline>Our Approach</Overline>
            <h2 className="mt-6 font-serif text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
              Reach audiences built around <em className="italic text-mutedblue">ideas</em>.
            </h2>
          </FadeIn>
        </div>
      </div>

      <div className="md:col-span-7">
        <FadeIn delay={0.1}>
          <p className="text-base md:text-lg text-charcoal/75 leading-relaxed max-w-xl">
            Not all YouTube audiences are the same. Informational creators attract
            viewers who actively seek explanations, analysis and deeper
            understanding. We help brands identify relevant creators and develop
            sponsorship opportunities that fit naturally into their content.
          </p>
        </FadeIn>

        <div className="mt-16">
          {BENEFITS.map((b, i) => (
            <FadeIn key={b.n} delay={0.1 + i * 0.1}>
              <div
                className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 border-t border-black/10 last:border-b"
                data-testid={`approach-benefit-${b.n}`}
              >
                <span className="font-serif text-sm text-mutedblue pt-1">{b.n}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight group-hover:text-mutedblue transition-colors duration-300">
                    {b.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-charcoal/70 leading-relaxed max-w-lg">
                    {b.text}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </div>
  </section>
);
